import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "请选择"
    },
    on: {
      change: _vm.selectGame
    },
    model: {
      value: _vm.game_id,
      callback: function callback($$v) {
        _vm.game_id = $$v;
      },
      expression: "game_id"
    }
  }, _vm._l(_vm.gameList, function (item) {
    return _c("el-option", {
      key: item.game_id,
      attrs: {
        label: item.name,
        value: item.game_id
      }
    });
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };